import authentication from '@/modules/apies/authentication'
import user from '@/modules/apies/user/user'
import userrole from '@/modules/apies/user/userrole'
import userpermission from '@/modules/apies/user/userpermission'
import usertoken from '@/modules/apies/user/usertoken'
import ordercategory from '@/modules/apies/order/ordercategory'
import ordercategoryprocess from '@/modules/apies/order/ordercategoryprocess'
import color from '@/modules/apies/order/color'
import clinic from '@/modules/apies/clinic'
import payment from '@/modules/apies/payment'
import clinictariff from '@/modules/apies/clinictariff'
import order from '@/modules/apies/order/order'
import salary from '@/modules/apies/user/salary'
import invoice from '@/modules/apies/invoice'
import invoiceorder from '@/modules/apies/invoiceorder'
import usertransaction from '@/modules/apies/user/usertransaction'
import userordercategoryprocess from '@/modules/apies/user/userordercategoryprocess'
import pettyCash from '@/modules/apies/pettycash'

export default {
  ordercategory,
  authentication,
  user,
  userrole,
  userpermission,
  usertoken,
  clinic,
  ordercategoryprocess,
  payment,
  clinictariff,
  order,
  salary,
  invoice,
  color,
  invoiceorder,
  usertransaction,
  userordercategoryprocess,
  pettyCash,
}
